import { Button } from "ui/components/button";
import { Icon } from "components";
import { LOADER2 } from "icons";

export default function ButtonWithLoading({
  isLoading = false,
  children,
  className,
  onClick = () => {},
  variant = "outline",
  disabled = false,
  ...rest
}) {
  return (
    <Button
      variant={variant}
      className={className}
      onClick={onClick}
      disabled={isLoading || disabled}
      {...rest}
    >
      {isLoading && <Icon icon={LOADER2} className="animate-spin " />}
      {children}
    </Button>
  );
}
